import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export function encodeQueryData(params) {
  if (!params || !Object.keys(params).length) return '';
  return encodeURIComponent(JSON.stringify(params));
}

// 兼容双重编码：部分客户端（如 Mac 端 IM）转发链接时会对参数值再编码一层，
// 并把 #hash 片段（如 #target=out）并入 queryData 值，故逐层解码并剥离杂质后再解析
export function decodeQueryData(str) {
  if (!str) return null;
  var decoded = str;
  for (var i = 0; i < 2; i++) {
    // 剥离混入参数值的尾部杂质（#target=out 等）：截取首个 { 到末个 } 的 JSON 主体
    var start = decoded.indexOf('{');
    var end = decoded.lastIndexOf('}');
    if (start !== -1 && end > start) {
      try {
        return JSON.parse(decoded.slice(start, end + 1));
      } catch (e) {
        // JSON 主体解析失败：尝试再解码一层后重试
      }
    }
    if (i === 0) {
      try {
        var next = decodeURIComponent(decoded);
        if (next === decoded) return null;
        decoded = next;
      } catch (e) {
        return null;
      }
    }
  }
  return null;
}

// 白名单合并：仅回填 searchForm 中已存在的字段，忽略未知字段与空值，避免 URL 参数污染请求
export function mergeQueryData(searchForm, queryData) {
  if (!queryData) return;
  Object.keys(queryData).forEach(function (key) {
    var value = queryData[key];
    if (key in searchForm && value !== undefined && value !== null && value !== '') {
      searchForm[key] = value;
    }
  });
}